<app-dialog [visible]="visible" (closed)="onDialogHide()" [closable]="false" [showCloseButton]="false"
    class="w-[40vw] max-w-[75rem] h-[80vh]">
    <ng-template #headerTemplate>
        <div class="flex items-center justify-between w-full">
            <h3 class="font-bold text-base sm:text-lg">Upload project knowledge</h3>
            <i class="pi pi-times cursor-pointer" (click)="onClose()"></i>
        </div>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-6 h-full">
            <!-- Radio Buttons: With KB / Without KB -->
            <div class="pb-4 border-b">
                <div class="text-sm font-medium text-gray-700 mb-3">How do you want to upload?</div>
                <div class="flex items-center gap-6">
                    <div class="flex items-center gap-2">
                        <p-radioButton [value]="'withoutKB'" [(ngModel)]="uploadMode" name="uploadMode"
                            inputId="withoutKB" (onClick)="onUploadModeChange('withoutKB')"></p-radioButton>
                        <label for="withoutKB" class="cursor-pointer text-sm text-gray-700">Without knowledge
                            base</label>
                    </div>
                    <div class="flex items-center gap-2">
                        <p-radioButton [value]="'withKB'" [(ngModel)]="uploadMode" name="uploadMode" inputId="withKB"
                            (onClick)="onUploadModeChange('withKB')"></p-radioButton>
                        <label for="withKB" class="cursor-pointer text-sm text-gray-700">With knowledge base</label>
                    </div>
                </div>
            </div>

            <div class="flex flex-row gap-4 flex-1 min-h-0 overflow-hidden">
                <!-- Left Section: Upload Configuration -->
                <div class="flex flex-col flex-1  shadow-sm bg-white min-w-0 overflow-hidden">
                    <!-- Knowledge Base Dropdown (only for "With KB" mode) -->
                    @if(uploadMode === 'withKB') {
                    <div class="mb-4">
                        <label class="block text-sm font-medium text-gray-700 mb-2">Select knowledge base</label>
                        <app-multi-select [(ngModel)]="selectedKnowledgeBases" [options]="knowledgeBaseOptions"
                            [config]="multiSelectConfig" optionLabel="label" optionValue="value">
                        </app-multi-select>
                    </div>
                    }

                    <!-- File Upload Area -->
                    <div class="flex-1 min-h-0 overflow-hidden">
                        <app-file-drop [multiple]="true" [fileTypes]="['.pdf', '.docx', '.zip', '.doc', '.xlsx', '.xls']"
                            [maxFileSize]="50 * 1024 * 1024" [existingFiles]="selectedFiles"
                            (uploadData)="onFilesSelected($event)" (removeFile)="onFileRemoved($event)">
                        </app-file-drop>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button variant="filled" severity="primary" label="Upload" (clicked)="onUpload()"
                [disabled]="!isUploadEnabled()" [enableThrottle]="true">
            </app-button>
        </div>
    </ng-template>
</app-dialog>